import React, { useState } from "react";
import Swal from "sweetalert2";
import { indianStates, uomOptions } from "../Services/CommonService";
import { IAddItemRequest } from "../Interfaces/IInventory";
import { TextField } from "@mui/material";
import Select from "react-select";
import { addItem } from "../Services/inventoryService";
import { useSnackbar } from "notistack";
import { MSG_ITEM_ADDED, MSG_ITEM_NAME_REQUIRED, MSG_ITEM_NOT_CREATED, MSG_PLEASE_FILL_ALL_REQUIRED_FIELDS, MSG_QUANTITY_REQUIRED, MSG_SELL_TYPE_REQUIRED, MSG_SELLING_PRICE_MUST_BE_POSITIVE, MSG_STOCK_QUANTITY_REQUIRED, MSG_UOM_REQUIRED } from "../Constants/MessageConstant";
import { LBL_CANCEL, LBL_HSN, LBL_ITEM_NAME, LBL_SAVE, LBL_SAVING, LBL_SELLING_PRICE, LBL_STOCK_QUANTITY, PLACEHOLDER_SELECT_UOM } from "../Constants/LabelConstants";
interface AddItemPopupProps {
  onSave: (data: IAddItemRequest) => void; // Callback to send data to parent
  onClose: () => void; 
  orgId: string;
}
const AddItemModelPopup: React.FC<AddItemPopupProps> = ({
  onSave,
  onClose,
  orgId,
}) => {
    const [newItem, setNewItem] = useState<Omit<IAddItemRequest, "itemId">>({
        name: "",
        brandId: "",
        categoryId: "",
        manufacturerId: "",
        hsn: "",
        taxId: 0,
        sku: "",
        upc: "",
        ian: "",
        itemTypeId: "",
        unit: "",
        costPrice: "",
        sellingPrice: "",
        quantity: 0,
        isActive: true,
        createdDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        updatedBy: "",
        createdBy: "admin_user",
        createdByIp: "",
        updatedByIp: "",
        itemAttribute: [],
        orgId: "",
        taxable: true,
        createAttributes: false,
        type: "Goods",
        reorderPoint: 0,
        desc: "",
        itemType: "Inventory",
        uom: "",
        warehouse: "",
        warehouseId: 1, // Add this line
        //stockQuantity: 0,
        discountRate: 0,
        batchNumber: 0,
        expiryDate: "",
        lotNumber: 0,
        additionalFieldsOpen: false,
        categoryName:'',
      });    
  const [loading, setLoading] = useState(false);
  const [itemNameError, setItemNameError] = useState(false);
  const [sellingPriceError, setSellingPriceError] = useState(false);
  const [quantityError, setQuantityError] = useState(false);
  const [uomError, setUomError] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleSave = async () => {
     const {name,quantity,sellingPrice,uom} = newItem;
    //companyName need to handle
    if (!name || !quantity || !sellingPrice || !uom) {
      // Swal.fire({
      //   icon: "warning",
      //   title: "Please fill all required fields.",
      //   text: "All fields are required to create a new item.",
      //   customClass: {
      //     container: "swal-validation-errors",
      //   },
      //   backdrop: `
      //     rgba(0,0,0,0.4)
      //     center
      //     no-repeat
      //   `,
      // });
      // const swalValidationErrors = document.querySelector(
      //   ".swal-validation-errors"
      // ) as HTMLElement;
      // if (swalValidationErrors) {
      //   swalValidationErrors.style.zIndex = "10000";
      // }
      enqueueSnackbar(MSG_PLEASE_FILL_ALL_REQUIRED_FIELDS, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        preventDuplicate: true,
      });
      
      return;
    }
   
     setLoading(true);
    try {
        const itemId = Date.now();
        const itemData = { itemId, ...newItem };
        const response = await addItem(itemData);//itemData
        itemData.itemId = response?.itemData?.itemId; //Added the newly added customer id.
        if (response.success) {
            //setItems([...items, itemData]);
            // Swal.fire({
            //   title: "Item added successfully!",
            //   icon: "success",
            //   confirmButtonText: "Ok",
            // });
            enqueueSnackbar(MSG_ITEM_ADDED, {
              variant: "success",
            });
            setNewItem({
              name: "",
              brandId: "",
              categoryId: "",
              manufacturerId: "",
              hsn: "",
              taxId: 0,
              sku: "",
              upc: "",
              ian: "",
              itemTypeId: "",
              unit: "",
              costPrice: "",
              sellingPrice: "",
              quantity: "",
              isActive: true,
              createdDate: new Date().toISOString(),
              updatedDate: new Date().toISOString(),
              updatedBy: "",
              createdBy: "admin_user",
              createdByIp: "",
              updatedByIp: "",
              itemAttribute: [],
              orgId: "",
              taxable: true,
              createAttributes: false,
              type: "Goods",
              reorderPoint: 0,
              desc: "",
              itemType: "Inventory",
              uom: "kg",
              expiryDate: "",
              batchNumber: 0,
              lotNumber: 0,
              discountRate: 0,
              warehouseId: 1,
              warehouse: "",
              categoryName:"",
            });
          } else {
            // Swal.fire({
            //   title: "Failed to add item",
            //   text: response.message,
            //   icon: "error",
            //   confirmButtonText: "Ok",
            // });
            enqueueSnackbar(response.message, {
              variant: "error",
            });
          }
    //   Swal.fire({
    //     icon: "success",
    //     title: "User Created",
    //     text: response.message,
    //   });
      onSave(itemData); // Pass the customer to the parent
      setLoading(false);
      onClose(); // Close the popup
    } catch (error) {
      // Swal.fire({
      //   icon: "error",
      //   title: "Failed to create user",
      //   text: "Please try again.",
      // });
      enqueueSnackbar(MSG_ITEM_NOT_CREATED, {
        variant: "error",
      });
      setLoading(false);
    }
  };

//   //Handle state onChanges
//   const handleStateChange = (e: { target: { value: any; }; }) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       address: { ...prevData.address, state: e.target.value },
//     }));
//   };
  

  return (
    <div className="popup">
      <div className="popup-content">
        {/* Close Button */}
      <button
        onClick={onClose}
        style={{
          position: "relative",
          float: "right",
          background: "red",
          border: "none",
          fontSize: "24px",
          cursor: "pointer",
          color: "#333",
          left: "10px",
          bottom: "15px",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        &times;
      </button>
        <h3>Add New Item</h3>
        <div className="form-group">
        <TextField
              //className="input-item-name"
              label={LBL_ITEM_NAME}
              required
              variant="outlined"
              value={newItem.name}
              onChange={(e) => {
                setNewItem({ ...newItem, name: e.target.value });
                if (e.target.value) {
                  setItemNameError(false);
                }
              }}
              onBlur={() => {
                if (!newItem.name) {
                  setItemNameError(true);
                }
              }}
              error={itemNameError}
              helperText={itemNameError ? MSG_ITEM_NAME_REQUIRED+"*" : ""}
              InputLabelProps={{
                style: { color: "black" },
              }}
            />
            </div>
            <div className="form-group">
            <TextField
             // className="input-hsn"
              label={LBL_HSN}
              //required
              variant="outlined"
              value={newItem.hsn}
              onChange={(e) => setNewItem({ ...newItem, hsn: e.target.value })}
            />
            </div>
            <div className="form-group">
            <TextField
              //className="input-selling-price"
              label={LBL_SELLING_PRICE}
              type="number"
              variant="outlined"
              required
              value={newItem.sellingPrice}
              // onChange={(e) => {
              //   setNewItem({ ...newItem, sellingPrice: e.target.value });
              //   if (e.target.value) {
              //     setSellingPriceError(false);
              //   }
              // }}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  setNewItem({ ...newItem, sellingPrice: e.target.value });
                  if (e.target.value) {
                    setSellingPriceError(false);
                  }
                } else {
                  // Swal.fire({
                  //   icon: "warning",
                  //   title: "Invalid Selling Price",
                  //   text: "Selling Price must be greater than or equalto zero.",
                  // });
                  enqueueSnackbar(
                    MSG_SELLING_PRICE_MUST_BE_POSITIVE,
                    {
                      variant: "warning",
                    }
                  );
                }
              }}
              onBlur={() => {
                if (!newItem.name) {
                  setSellingPriceError(true);
                }
              }}
              error={sellingPriceError}
              helperText={
                sellingPriceError ? MSG_SELL_TYPE_REQUIRED+"*" : ""
              }
              InputLabelProps={{
                style: { color: "black" },
              }}    
            />
            </div>
            <div className="form-group">
            <TextField
                label={LBL_STOCK_QUANTITY}
                type="number"
                variant="outlined"
                required
                value={newItem.quantity}
                onChange={(e) => {
                    const value = Number(e.target.value);
                    if (value >= 0) {
                      setNewItem({ ...newItem, quantity: e.target.value });
                      if (e.target.value) {
                        setQuantityError(false);
                      }
                    } else {
                      // Swal.fire({
                      //   icon: "warning",
                      //   title: "Invalid Stock Quantity",
                      //   text: "Stock Quantity must be greater than or equal to zero.",
                      // });
                      enqueueSnackbar(
                        MSG_STOCK_QUANTITY_REQUIRED,
                        {
                          variant: "warning",
                        }
                      );
                      
                    }
                  }}
                  onBlur={() => {
                    if (!newItem.name) {
                        setQuantityError(true);
                    }
                  }}
                  error={quantityError}
                  helperText={
                    quantityError ? MSG_QUANTITY_REQUIRED+"*": ""
                  }
                  InputLabelProps={{
                    style: { color: "black" },
                  }}
                />
          </div>
          <div className="form-group">
          <div className="dropdown-column">
          <Select
            options={uomOptions}
            value={uomOptions.find((o) => o.value === newItem.uom) || null}
            onChange={(opt) => {
              setNewItem((prev) => ({ ...prev, uom: opt!.value }));
              setUomError(false);
            }}
            onBlur={() => !newItem.uom && setUomError(true)}
            placeholder={<span style={{ color: 'black' }}>{PLACEHOLDER_SELECT_UOM}</span>}
            isSearchable
            /** these two are critical for dropdowns in modals **/
            menuPosition="fixed"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                borderColor: uomError ? 'red' : base.borderColor,
                '&:hover': { borderColor: uomError ? 'red' : base.borderColor },
                minHeight: '38px',
              }),
            }}
          />
              {uomError && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {MSG_UOM_REQUIRED}
                </span>
              )}
            </div>
            </div>

        {/* Add other fields similarly */}
        <div className="popup-buttons">
          <button
            className="popup-button"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? LBL_SAVING : LBL_SAVE}
          </button>
          <button className="popup-button cancel" onClick={onClose}>
            {LBL_CANCEL}
          </button>
        </div>
      </div>
    </div>
  );
};
export default AddItemModelPopup;
